import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { dataAPI } from "../../api/axios";
import "./Attachments.css";
import { v4 as uuidv4 } from "uuid";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

const AddAttachment = ({
    attachments,
    setNewAttachments,
    setDialogContext,
    layerID,
    objectID,
    attachmentId,
}) => {
    const fileInput = useRef();
    const [statusMessage, setStatusMessage] = useState({ type: "", message: "" });
    const [showDialog, setShowDialog] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Loop over the files and send a request for each one
        for (const file of fileInput.current.files) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("data", file);

            try {
                const response = await dataAPI.post(
                    `/Layers/${layerID}/Data/${objectID}/Attachments/${attachmentId}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                const attachmentOID = response.data.attachmentOID;

                if (response.status === 201) {
                    setNewAttachments((attachments) => [
                        ...attachments,
                        { id: attachmentOID, name: file.name },
                    ]);
                    setStatusMessage({
                        type: "success",
                        message: "Attachment added successfully",
                    });
                }
            } catch (error) {
                if (!error.response) {
                    console.error("Network error:", error);
                    setStatusMessage({
                        type: "error",
                        message:
                            "An error occurred while adding the attachment. Please try again.",
                    });
                    setShowDialog(true);
                    return;
                }
            }
        }
    };

    const renderStatusDialog = () => {
        if (showDialog) {
            return (
                <Dialog title={statusMessage.type} onClose={() => setShowDialog(false)}>
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        {statusMessage.message}
                    </p>
                    <DialogActionsBar>
                        <Button
                            title="OK"
                            onClick={() =>
                                setShowDialog(false) && setDialogContext("viewAttachment")
                            }>
                            OK
                        </Button>
                    </DialogActionsBar>
                </Dialog>
            );
        }
    };

    useEffect(() => {
        if (statusMessage.type === "success") {
            setTimeout(() => setDialogContext("viewAttachment"), 2000);
            setShowDialog(true);
        }
    }, [statusMessage]);

    useEffect(() => {
        if (statusMessage.type === "error") {
            setShowDialog(true);
            setTimeout(() => setDialogContext("viewAttachment"), 2000);
        }
    }, [statusMessage]);

    return (
        <>
            <form onSubmit={handleSubmit}>
                <input
                    id="file"
                    type="file"
                    ref={fileInput}
                    accept="*"
                    capture="environment"
                    multiple
                />
                <div className="button-container">
                    <Button type="submit" className="submit-button">
                        Submit
                    </Button>
                    <Button
                        className="back-button"
                        onClick={() => setDialogContext("viewAttachment")}>
                        Back
                    </Button>
                </div>
            </form>

            {renderStatusDialog()}
        </>
    );
};

export default AddAttachment;
